var map = {
	"./icon-marker-bar-small.svg": 36386,
	"./icon-marker-cafe-small.svg": 89546,
	"./icon-marker-gas_station-small.svg": 43428,
	"./icon-marker-iqos-small.svg": 78661,
	"./icon-marker-store-small.svg": 48425
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56601;